export default "__VITE_ASSET__ByQMORyL__"